import React, { useEffect, useRef } from 'react';

export default function ConfirmDialog({
  open,
  title = 'Confirm',
  message = 'Are you sure?',
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  danger = false,
  onConfirm,
  onCancel,
}) {
  const confirmBtnRef = useRef(null);

  useEffect(() => {
    if (open) {
      const handler = (e) => { if (e.key === 'Escape') onCancel?.(); };
      document.addEventListener('keydown', handler);
      confirmBtnRef.current?.focus();
      return () => document.removeEventListener('keydown', handler);
    }
  }, [open, onCancel]);

  if (!open) return null;

  return (
    <div
      className="modal-overlay"
      onClick={(e) => { if (e.target === e.currentTarget) onCancel?.(); }}
      style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="confirm-title"
        className="modal-container"
        style={{
          background: 'var(--pico-card-background-color)',
          borderRadius: 8,
          padding: 24,
          minWidth: 320,
          maxWidth: 480,
          boxShadow: '0 4px 24px rgba(0,0,0,0.18)',
        }}
      >
        <h3 id="confirm-title" style={{ margin: '0 0 8px' }}>{title}</h3>
        <p style={{ color: 'var(--pico-muted-color)', margin: '0 0 20px' }}>{message}</p>
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <button onClick={onCancel} className="pico-btn secondary">{cancelLabel}</button>
          <button
            ref={confirmBtnRef}
            onClick={onConfirm}
            className="pico-btn"
            style={danger ? { background: 'var(--pico-del-color)', borderColor: 'var(--pico-del-color)' } : {}}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
